import { useContext } from 'react';
import SectionName from '~/constants/new-cars/SectionName';
import ParentModelContext from '~/context/new-cars/ParentModelContext';

// Available-vehicle total for the current section (Doors shares the modelVersions count).
export default function useAvailableCount(): number {
  const {
    activeSection,
    customizeOptions,
    modelVersions,
    trims,
    truckBodyStyles,
    years
  } = useContext(ParentModelContext);

  switch (activeSection) {
    case SectionName.Year:
      return years.count;
    case SectionName.Doors:
    case SectionName.ModelVersion:
      return modelVersions.data.count;
    case SectionName.Trim:
      return trims.data.count;
    case SectionName.TruckBodyStyle:
      return truckBodyStyles.data.count;
    case SectionName.Options:
    default:
      return customizeOptions.data.totalMatchingVehicles;
  }
}
